import React from 'react';
interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}
export function Container({
  children,
  className = ''
}: ContainerProps) {
  return <div className={`mx-auto w-full max-w-7xl px-6 lg:px-8 ${className}`} data-id="element-17">
      {children}
    </div>;
}